/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { InteractiveComponents } from '../../core/enums';
import { ScreenTaskControllerTypes } from '../../core/navigation/ScreenTaskControllerTypes';
import {
    clearActiveInteractiveComponent,
    setActiveInteractiveComponent,
} from '../interactivelayer/interactiveLayer.reducers';
import { setScreenTaskController } from '../screens/screens.reducers';
import { onKeyBackVideoPlayer } from '../videoplayer/navigation/videoplayernavigation.reducers';
import { onKeyBackAudioTrackOverlay } from '../videoplayer/overlays/audiotrackoverlay/audiotrackoverlay.reducers';
import { onKeyBackErrorOverlay } from '../videoplayer/overlays/erroroverlay/erroroverlay.reducers';
import { onKeyBackSubtitleAndCCLanguageOverlay } from '../videoplayer/overlays/subtitleandcclanguageoverlay/subtitleandcclanguageoverlay.reducers';
import {
    isAdultContentPlaybackActive,
    showPCPinOverlayForVideoPlayer,
} from '../videoplayer/videoplayer.reducers';
import {
    onKeyBackFullInfoBanner,
    onMouseClickLeftFullInfoBanner,
    onMouseClickRightFullInfoBanner,
} from './infobanner/fullinfobannernavigation.reducers';
import { showTrickPlayMenu } from './infobanner/infobanner.reducers';
import { onKeyBackStandardInfoBanner } from './infobanner/standardinfobannernavigation.reducers';
import { onKeyBackTrickplayMenu } from './infobanner/trickplaymenunavigation.reducers';
import { hideOneLineGuide } from './onelineguide/onelineguide.reducers';

export const onMouseClickRootInteractiveLayerOperations =
    () => (dispatch: Function, getState: Function) => {
        const { screenTaskController } = getState().screens;
        switch (screenTaskController) {
            case ScreenTaskControllerTypes.AUDIO_TRACK_OVERLAY:
                dispatch(onKeyBackAudioTrackOverlay());
                break;
            case ScreenTaskControllerTypes.FULL_INFO:
                dispatch(onKeyBackFullInfoBanner());
                dispatch(checkAndShowPCPinOverlay());
                break;
            case ScreenTaskControllerTypes.PLAYER_ERROR_OVERLAY:
                dispatch(onKeyBackErrorOverlay());
                dispatch(onKeyBackVideoPlayer());
                break;
            case ScreenTaskControllerTypes.STANDARD_INFO:
                dispatch(onKeyBackStandardInfoBanner());
                dispatch(checkAndShowPCPinOverlay());
                break;
            case ScreenTaskControllerTypes.SUBTITLE_AND_CC_LANGUAGE_OVERLAY:
                dispatch(onKeyBackSubtitleAndCCLanguageOverlay());
                break;
            case ScreenTaskControllerTypes.TRICKPLAY_MENU:
                dispatch(onKeyBackTrickplayMenu());
                dispatch(checkAndShowPCPinOverlay());
                break;
            case ScreenTaskControllerTypes.ONE_LINE_GUIDE_TASKS:
                dispatch(hideOneLineGuide());
                break;
            default:
                if (isAdultContentPlaybackActive()) dispatch(showPCPinOverlayForVideoPlayer());
                else dispatch(showTrickPlayMenu());
        }
    };

export const onMouseClickVideoPlayerUiInteractiveLayerOperations =
    () => (dispatch: Function, getState: Function) => {
        const { activeComponent } = getState().interactiveLayer;
        switch (activeComponent) {
            case InteractiveComponents.EAST:
                dispatch(onMouseClickRightFullInfoBanner());
                break;
            case InteractiveComponents.WEST:
                dispatch(onMouseClickLeftFullInfoBanner());
                break;
            default:
        }
    };

export const onMouseOutVideoPlayerUiOperations = () => (dispatch: Function, getState: Function) => {
    const { value } = getState().inputFactory;
    const { previousScreenTaskController } = getState().screens;
    switch (value) {
        case InteractiveComponents.EAST:
        case InteractiveComponents.WEST:
            dispatch(setScreenTaskController(previousScreenTaskController));
            dispatch(clearActiveInteractiveComponent());
            break;
        default:
    }
};

export const onMouseOverVideoPlayerUiOperations =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;
        switch (value) {
            case InteractiveComponents.EAST:
            case InteractiveComponents.WEST:
                dispatch(setActiveInteractiveComponent(value));
                dispatch(
                    setScreenTaskController(
                        ScreenTaskControllerTypes.LIVE_TV_INTERACTIVE_LAYER_TASKS,
                    ),
                );
                break;
            default:
        }
    };

const checkAndShowPCPinOverlay = () => (dispatch: Function) => {
    if (isAdultContentPlaybackActive()) dispatch(showPCPinOverlayForVideoPlayer());
};
